import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function LegalLayout({ lang, tKey, children }) {
  const { t } = useTranslation();
  return (
    <main className="aq-legal">
      <div className="aq-container">
        <nav aria-label="Breadcrumb" className="aq-crumbs">
          <Link to={`/${lang}`}>{t('nav.home')}</Link>
          <span aria-hidden="true">/</span>
          <span>{t(`${tKey}.title`)}</span>
        </nav>
        <header className="aq-legal__head">
          <span className="aq-eyebrow">{t(`${tKey}.title`)}</span>
          <h1 className="aq-legal__title">{t(`${tKey}.title`)}</h1>
          <p className="aq-legal__updated">{t(`${tKey}.updated`)}</p>
        </header>
        <article className="aq-legal__content">
          <p className="aq-legal__intro">{t(`${tKey}.intro`)}</p>
          {children}
        </article>
      </div>
    </main>
  );
}
